<div (click)="picker.open()" class="is-relative">
  <input matInput [matDatepicker]="picker" [min]="minDate" [max]="maxDate" [formControl]="date">

  <mat-datepicker [touchUi]="touchUi" #picker></mat-datepicker>

  <ng-content></ng-content>
</div>
